export const standardTicketCols = [
  { label: "Status", key: "status", sortable: true, adminOnly: false },
  { label: "ID", key: "ticket_id", sortable: true, adminOnly: false },
  {
    label: "Firstname",
    key: "firstName",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Lastname",
    key: "lastName",
    sortable: true,
    adminOnly: false
  },
  { label: "Phone", key: "phone", sortable: true, adminOnly: false },
  { label: "Email", key: "email", sortable: true, adminOnly: false },
  { label: "Type", key: "type", sortable: true, adminOnly: false },
  { label: "Full Price", key: "price", sortable: true, adminOnly: false },
  { label: "Role", key: "role", sortable: true, adminOnly: false },
  { label: "Ticket", key: "ticket", sortable: true, adminOnly: false },
  {
    label: "Alt Ticket",
    key: "ticket_alt",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Order ID",
    key: "order_id",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Transferred To",
    key: "transfer_to_data",
    sortable: true,
    adminOnly: false,
    width: "300px"
  },
  {
    label: "RSVP",
    key: "rsvp",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Assign",
    key: "assign_date",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Confirm",
    key: "confirm_date_format",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Check-in",
    key: "checkin_date_format",
    sortable: false,
    adminOnly: false
  },
  {
    label: "Consent",
    key: "consent_status",
    sortable: true,
    adminOnly: false
  },
  // {
  //   label: "Confirmed",
  //   key: "confirmed",
  //   sortable: false,
  //   adminOnly: false
  // },
  {
    label: "Disabled",
    key: "disabled",
    sortable: true,
    adminOnly: false
  },
  { label: "Promo Code", key: "pc", sortable: true, adminOnly: false },
  {
    label: "Referrer",
    key: "referrer",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Invite Code",
    key: "invite_code",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Invited By",
    key: "invite_by",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Send Invitation",
    key: "invite_by",
    sortable: true,
    adminOnly: false
  },
  // {
  //   label: "Progress",
  //   key: "progress",
  //   sortable: false,
  //   adminOnly: false,
  //   export: false
  // },
  { label: "Edit", key: "edit", sortable: false, adminOnly: false },
  {
    label: "Resend Ticket",
    key: "resend",
    sortable: true,
    adminOnly: true
  },
  {
    label: "Attendee Message",
    key: "attendee_messages",
    sortable: true,
    adminOnly: true
  },
  {
    label: "Reminder",
    key: "reminders",
    sortable: true,
    adminOnly: true
  },
  {
    label: "Message",
    key: "message",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Language",
    key: "language",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Last Update",
    key: "last_update_date",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Request Info",
    key: "info",
    sortable: true,
    adminOnly: true
  }

  //  { label: "Price", key: "price", sortable: false, adminOnly: false },
  //  { label: "Ticket", key: "ticket", sortable: false, adminOnly: false },
  //  { label: "Paid", key: "paid_date", sortable: false, adminOnly: false },
  //  { label: "Approve", key: "approve", sortable: false, adminOnly: false },
];

export const freeTicketCols = [
  { label: "Status", key: "status", sortable: true, adminOnly: false },
  { label: "ID", key: "ticket_id", sortable: true, adminOnly: false },
  {
    label: "Firstname",
    key: "firstName",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Lastname",
    key: "lastName",
    sortable: true,
    adminOnly: false
  },
  { label: "Phone", key: "phone", sortable: true, adminOnly: false },
  { label: "Email", key: "email", sortable: true, adminOnly: false },
  { label: "Type", key: "type", sortable: true, adminOnly: false },
  { label: "Full Price", key: "price", sortable: true, adminOnly: false },
  { label: "Role", key: "role", sortable: true, adminOnly: false },
  { label: "Ticket", key: "ticket", sortable: true, adminOnly: false },
  {
    label: "Alt Ticket",
    key: "ticket_alt",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Registration ID",
    key: "order_id",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Transferred To",
    key: "transfer_to_data",
    sortable: true,
    adminOnly: false
  },
  {
    label: "RSVP",
    key: "rsvp",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Assign",
    key: "assign_date",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Confirm",
    key: "confirm_date_format",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Check-in",
    key: "checkin_date_format",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Consent",
    key: "consent_status",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Confirmed",
    key: "confirmed",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Disabled",
    key: "disabled",
    sortable: true,
    adminOnly: false
  },
  { label: "Promo Code", key: "pc", sortable: true, adminOnly: false },
  {
    label: "Referrer",
    key: "referrer",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Invite Code",
    key: "invite_code",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Invited By",
    key: "invite_by",
    sortable: true,
    adminOnly: true
  },
  {
    label: "Send Invitation",
    key: "",
    sortable: true,
    adminOnly: true
  },
  // {
  //   label: "Progress",
  //   key: "progress",
  //   sortable: false,
  //   adminOnly: false,
  //   export: false
  // },
  { label: "Edit", key: "edit", sortable: false, adminOnly: false },
  {
    label: "Resend Ticket",
    key: "resend",
    sortable: true,
    adminOnly: true
  },
  {
    label: "Attendee Message",
    key: "attendee_messages",
    sortable: true,
    adminOnly: true
  },
  {
    label: "Reminder",
    key: "reminders",
    sortable: true,
    adminOnly: true
  },
  {
    label: "Message",
    key: "message",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Language",
    key: "language",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Last Update",
    key: "last_update_date",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Request Info",
    key: "info",
    sortable: true,
    adminOnly: true
  }

  //  { label: "Price", key: "price", sortable: false, adminOnly: false },
  //  { label: "Ticket", key: "ticket", sortable: false, adminOnly: false },
  //  { label: "Paid", key: "paid_date", sortable: false, adminOnly: false },
  //  { label: "Approve", key: "approve", sortable: false, adminOnly: false },
];

export const pttgcTicketCols = [
  { label: "Status", key: "status", sortable: true, adminOnly: false },
  { label: "ID", key: "ticket_id", sortable: true, adminOnly: false },
  {
    label: "Firstname",
    key: "firstName",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Lastname",
    key: "lastName",
    sortable: true,
    adminOnly: false
  },
  { label: "Phone", key: "phone", sortable: true, adminOnly: false },
  { label: "Email", key: "email", sortable: true, adminOnly: false },
  { label: "Type", key: "type", sortable: true, adminOnly: false },
  { label: "Full Price", key: "price", sortable: true, adminOnly: false },
  { label: "Ticket", key: "ticket", sortable: true, adminOnly: false },
  {
    label: "Alt Ticket",
    key: "ticket_alt",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Registration ID",
    key: "order_id",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Transferred To",
    key: "transfer_to_data",
    sortable: true,
    adminOnly: false,
    width: "300px"
  },
  {
    label: "RSVP",
    key: "rsvp",
    sortable: true,
    adminOnly: false
  },
  // {
  //   label: "Assign",
  //   key: "assign_date",
  //   sortable: false,
  //   adminOnly: false
  // },
  {
    label: "Confirm",
    key: "confirm_date_format",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Check-in",
    key: "checkin_date_format",
    sortable: true,
    adminOnly: false
  },
  // {
  //   label: "Consent",
  //   key: "consent_status",
  //   sortable: false,
  //   adminOnly: true
  // },
  {
    label: "Disabled",
    key: "disabled",
    sortable: true,
    adminOnly: true
  },
  // { label: "Promo Code", key: "pc", sortable: false, adminOnly: false },
  {
    label: "Focal Point",
    key: "referrer",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Invite Code",
    key: "invite_code",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Invited By",
    key: "invite_by",
    sortable: true,
    adminOnly: false
  },
  // {
  //   label: "Send Invitation",
  //   key: "",
  //   sortable: false,
  //   adminOnly: true
  // },
  // {
  //   label: "Progress",
  //   key: "progress",
  //   sortable: false,
  //   adminOnly: false,
  //   export: false
  // },
  { label: "Edit", key: "edit", sortable: false, adminOnly: false },
  {
    label: "Resend Ticket",
    key: "resend",
    sortable: true,
    adminOnly: true
  },
  {
    label: "Attendee Message",
    key: "attendee_messages",
    sortable: true,
    adminOnly: true
  },
  {
    label: "Reminder",
    key: "reminders",
    sortable: true,
    adminOnly: true
  },
  {
    label: "Message",
    key: "message",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Language",
    key: "language",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Remark",
    key: "remark",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Last Update",
    key: "last_update_date",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Request Info",
    key: "info",
    sortable: true,
    adminOnly: true
  }

  //  { label: "Price", key: "price", sortable: false, adminOnly: false },
  //  { label: "Ticket", key: "ticket", sortable: false, adminOnly: false },
  //  { label: "Paid", key: "paid_date", sortable: false, adminOnly: false },
  //  { label: "Approve", key: "approve", sortable: false, adminOnly: false },
];

export const onlineTicketCols = [
  { label: "ID", key: "ticket_id", sortable: true, adminOnly: false },
  {
    label: "Firstname",
    key: "firstName",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Lastname",
    key: "lastName",
    sortable: true,
    adminOnly: false
  },
  { label: "Phone", key: "phone", sortable: true, adminOnly: false },
  { label: "Email", key: "email", sortable: true, adminOnly: false },
  { label: "Type", key: "type", sortable: true, adminOnly: false },
  { label: "Full Price", key: "price", sortable: true, adminOnly: false },
  { label: "Price", key: "price", sortable: true, adminOnly: false },
  { label: "Ticket", key: "ticket", sortable: true, adminOnly: false },
  { label: "Order", key: "order_id", sortable: true, adminOnly: false },
  { label: "Paid", key: "paid_date", sortable: true, adminOnly: false },
  { label: "Approve", key: "approve", sortable: true, adminOnly: false },
  {
    label: "Disabled",
    key: "disabled",
    sortable: true,
    adminOnly: false
  },
  { label: "Promo Code", key: "pc", sortable: true, adminOnly: false },
  {
    label: "Referrer",
    key: "referrer",
    sortable: true,
    adminOnly: false
  },
  { label: "Checkin", key: "checkin_date_format", sortable: true, adminOnly: false },
  { label: "Edit", key: "edit", sortable: false, adminOnly: false },
  {
    label: "Resend Ticket",
    key: "resend",
    sortable: true,
    adminOnly: true
  },
  {
    label: "Attendee Message",
    key: "attendee_messages",
    sortable: true,
    adminOnly: true
  },
  {
    label: "Reminder",
    key: "reminders",
    sortable: true,
    adminOnly: true
  },
  { label: "Message", key: "message", sortable: true, adminOnly: false },
  {
    label: "Language",
    key: "language",
    sortable: true,
    adminOnly: false
  },
  {
    label: "Last Update",
    key: "last_update_date",
    sortable: true,
    adminOnly: false
  },
  // {
  //   label: "Progress",
  //   key: "progress",
  //   sortable: false,
  //   adminOnly: false,
  //   export: false
  // },
  { label: "Join", key: "join", sortable: true, adminOnly: true },
  { label: "Zoom", key: "zoom", sortable: false, adminOnly: true },
  {
    label: "Panelist",
    key: "isPanelist",
    sortable: true,
    adminOnly: true
  },
  // {
  //   label: "Zoom Join Link",
  //   key: "zoom_join_url",
  //   sortable: false,
  //   adminOnly: true
  // },
  {
    label: "Request Info",
    key: "request_info",
    sortable: true,
    adminOnly: true
  }
];

export const adminOrderCols = [
  {
    label: "Status",
    key: "rowstatus"
  },
  { label: "ID", key: "order_id", sortable: false },
  { label: "Pay Code", key: "unique_id", sortable: false },
  { label: "Name", key: "name", sortable: false, sortable: false },
  { label: "Phone", key: "phone", sortable: false },
  { label: "Email", key: "email", sortable: false },
  { label: "Amount", key: "amount", sortable: false },
  { label: "Qty", key: "quantity", sortable: false },
  { label: "Upload", key: "upload", sortable: false },
  { label: "Approve", key: "approve", sortable: false },
  { label: "Channel", key: "paidby", sortable: false },
  {
    label: "Errors",
    key: "errors",
    sortable: false
  },
  { label: "Register", key: "register_date", sortable: false },
  { label: "Paid", key: "paid_date", sortable: false },
  { label: "Upload", key: "upload_date", sortable: false },
  { label: "Approved", key: "confirm_date", sortable: false },
  { label: "Deadline", key: "deadline", sortable: false },
  { label: "Action", key: "actions", sortable: false },
  // {
  //   label: "Progress",
  //   key: "progress",
  //   sortable: false,
  //   adminOnly: false,
  //   export: false
  // },
  { label: "Remark", key: "remark", sortable: false },
  { label: "Country", key: "ipcountry", sortable: false },
  { label: "Ref", key: "ref", sortable: false },
  {
    label: "Promotion",
    key: "promotion",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Invited By",
    key: "invitedby",
    sortable: true,
    adminOnly: false,
    export: true
  }
];

export const customerOrderCols = [
  {
    label: "Status",
    key: "rowstatus"
  },
  { label: "ID", key: "order_id", sortable: false },
  { label: "Pay Code", key: "unique_id", sortable: false },
  { label: "Name", key: "name", sortable: false},
  { label: "Phone", key: "phone", sortable: false },
  { label: "Email", key: "email", sortable: false },
  { label: "Amount", key: "amount", sortable: false },
  { label: "Qty", key: "quantity", sortable: false },
  { label: "Upload", key: "upload", sortable: false },
  { label: "Approve", key: "approve", sortable: false },
  { label: "Channel", key: "paidby", sortable: false },
  { label: "Register", key: "register_date", sortable: false },
  { label: "Paid", key: "paid_date", sortable: false },
  { label: "Upload", key: "upload_date", sortable: false },
  { label: "Approved", key: "confirm_date", sortable: false },
  // {
  //   label: "Progress",
  //   key: "progress",
  //   sortable: false,
  //   adminOnly: false,
  //   export: false
  // },
  { label: "Remark", key: "remark", sortable: false },
  { label: "Country", key: "ipcountry", sortable: false },
  { label: "Ref", key: "ref", sortable: false },
  {
    label: "Promotion",
    key: "promotion",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Invited By",
    key: "invitedby",
    sortable: true,
    adminOnly: false,
    export: true
  }
];

export const pttgcOrderCols = [
  {
    label: "Status",
    key: "rowstatus"
  },
  { label: "ID", key: "order_id", sortable: false },
  { label: "Booking Code", key: "unique_id", sortable: false },
  { label: "Name", key: "name", sortable: false },
  { label: "Phone", key: "phone", sortable: false },
  { label: "Email", key: "email", sortable: false },
  // { label: "Amount", key: "amount", sortable: false },
  { label: "Qty", key: "quantity", sortable: false },
  // { label: "Upload", key: "upload", sortable: false },
  { label: "Confirmed", key: "approve", sortable: false },
  // { label: "Channel", key: "paidby", sortable: false },
  { label: "Register", key: "register_date", sortable: false },
  // { label: "Paid", key: "paid_date", sortable: false },
  { label: "Upload", key: "upload_date", sortable: false },
  { label: "Confirm Date", key: "confirm_date", sortable: false },
  // {
  //   label: "Progress",
  //   key: "progress",
  //   sortable: false,
  //   adminOnly: false,
  //   export: false
  // },
  { label: "Remark", key: "remark", sortable: false },
  // { label: "Country", key: "ipcountry", sortable: false },
  { label: "Focal Point", key: "ref", sortable: false }
];

export const standardOrderCols = [
  {
    label: "Status",
    key: "rowstatus",
    sortable: true,
    adminOnly: false
  },
  {
    label: "ID",
    key: "order_id",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Pay Code",
    key: "unique_id",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Name",
    key: "name",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Phone",
    key: "phone",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Email",
    key: "email",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Amount",
    key: "amount",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Qty",
    key: "quantity",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Pay Slip",
    key: "upload",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Confirmed",
    key: "approve",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Channel",
    key: "paidby",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Transfer To",
    key: "transfer_to",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Errors",
    key: "errors",
    sortable: true,
    adminOnly: true,
    export: true
  },
  {
    label: "Register",
    key: "register_date",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Upload",
    key: "upload_date",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Paid",
    key: "paid_date",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Confirm",
    key: "confirm_date",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Deadline",
    key: "deadline",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Send Invitation",
    key: "send_invitation",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Action",
    key: "actions",
    sortable: false,
    adminOnly: false,
    export: true
  },
  // {
  //   label: "Progress",
  //   key: "progress",
  //   sortable: false,
  //   adminOnly: false,
  //   export: false
  // },
  {
    label: "Remark",
    key: "remark",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Country",
    key: "ipcountry",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Ref",
    key: "ref",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Promotion",
    key: "promotion",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Invited By",
    key: "invitedby",
    sortable: true,
    adminOnly: false,
    export: true
  }
];

export const freeOrderCols = [
  {
    label: "Status",
    key: "rowstatus",
    adminOnly: false,
    export: true
  },
  {
    label: "ID",
    key: "order_id",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Booking Code",
    key: "unique_id",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Name",
    key: "name",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Phone",
    key: "phone",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Email",
    key: "email",
    sortable: false,
    adminOnly: false,
    export: true
  },
  // {
  //   label: "Amount",
  //   key: "amount",
  //   sortable: false,
  //   adminOnly: false,
  //   export: true
  // },
  {
    label: "Qty",
    key: "quantity",
    sortable: false,
    adminOnly: false,
    export: true
  },
  // {
  //   label: "Upload",
  //   key: "upload",
  //   sortable: false,
  //   adminOnly: false,
  //   export: true
  // },
  {
    label: "View",
    key: "orderdata",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Action",
    key: "actions",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Confirmed",
    key: "approve",
    sortable: false,
    adminOnly: false,
    export: true
  },
  // {
  //   label: "Channel",
  //   key: "paidby",
  //   sortable: false,
  //   adminOnly: false,
  //   export: true
  // },
  {
    label: "Transferred To",
    key: "transfer_to_data",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Errors",
    key: "errors",
    sortable: false,
    adminOnly: true,
    export: true
  },
  {
    label: "Register",
    key: "register_date",
    sortable: false,
    adminOnly: false,
    export: true
  },
  // {
  //   label: "Upload",
  //   key: "upload_date",
  //   sortable: false,
  //   adminOnly: false,
  //   export: true
  // },
  // {
  //   label: "Paid",
  //   key: "paid_date",
  //   sortable: false,
  //   adminOnly: false,
  //   export: true
  // },
  // {
  //   label: "Confirm",
  //   key: "confirm_date",
  //   sortable: false,
  //   adminOnly: false,
  //   export: true
  // },
  // {
  //   label: "Deadline",
  //   key: "deadline",
  //   sortable: false,
  //   adminOnly: false,
  //   export: true
  // },
  {
    label: "Send Invitation",
    key: "send_invitation",
    sortable: false,
    adminOnly: false,
    export: true
  },
  // {
  //   label: "Progress",
  //   key: "progress",
  //   sortable: false,
  //   adminOnly: false,
  //   export: false
  // },
  {
    label: "Remark",
    key: "remark",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Country",
    key: "ipcountry",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Ref",
    key: "ref",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Promotion",
    key: "promotion",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Invited By",
    key: "invitedby",
    sortable: true,
    adminOnly: false,
    export: true
  }
];

export const exportStandardOrderCols = [
  {
    label: "Status",
    key: "rowstatus",
    adminOnly: false
  },
  {
    label: "ID",
    key: "order_id",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Pay Code",
    key: "unique_id",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Name",
    key: "name",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Phone",
    key: "phone",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Email",
    key: "email",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Amount",
    key: "amount",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Withholding Tax",
    key: "",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Promocode",
    key: "",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Discount",
    key: "",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Qty",
    key: "quantity",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Transferred To",
    key: "transferd_to_name",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Pay Slip",
    key: "upload",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Approve",
    key: "approve",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Channel",
    key: "paidby",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Errors",
    key: "errors",
    sortable: false,
    adminOnly: true,
    export: true
  },
  {
    label: "Register",
    key: "register_date",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Upload",
    key: "upload_date",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Paid",
    key: "paid_date",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Approved",
    key: "confirm_date",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Deadline",
    key: "deadline",
    sortable: false,
    adminOnly: false,
    export: true
  },
  // {
  //   label: "Progress",
  //   key: "progress",
  //   sortable: false,
  //   adminOnly: false,
  //   export: false
  // },
  {
    label: "Remark",
    key: "remark",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Country",
    key: "ipcountry",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Ref",
    key: "ref",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Promotion",
    key: "promotion",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Invited By",
    key: "invitedby",
    sortable: true,
    adminOnly: false,
    export: true
  }
];

export const exportFreeOrderCols = [
  {
    label: "Status",
    key: "rowstatus",
    adminOnly: false,
    export: true
  },
  {
    label: "ID",
    key: "order_id",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Booking Code",
    key: "unique_id",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Name",
    key: "name",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Phone",
    key: "phone",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Email",
    key: "email",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Qty",
    key: "quantity",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Transferred To",
    key: "transfer_to_data",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Confirmed",
    key: "approve",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Errors",
    key: "errors",
    sortable: false,
    adminOnly: true,
    export: true
  },
  {
    label: "Register",
    key: "register_date",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Confirm",
    key: "confirm_date",
    sortable: false,
    adminOnly: false,
    export: true
  },
  // {
  //   label: "Progress",
  //   key: "progress",
  //   sortable: false,
  //   adminOnly: false,
  //   export: false
  // },
  {
    label: "Remark",
    key: "remark",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Country",
    key: "ipcountry",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Ref",
    key: "ref",
    sortable: false,
    adminOnly: false,
    export: true
  },
  {
    label: "Promotion",
    key: "promotion",
    sortable: true,
    adminOnly: false,
    export: true
  },
  {
    label: "Invited By",
    key: "invitedby",
    sortable: true,
    adminOnly: false,
    export: true
  }
];
